import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateH: SceneTemplate = {
    name: "תבנית ח",
    aspectRatio: "1:1.414",
    branding: {
        background: "primary",
        foreground: {
            color: "secondary",
            size: {
                width: 100,
                height: 30,
            },
            location: {
                x: 0,
                y: 70,
            },
        },
    },
    avatar: undefined,
    scene: {
        scale: 91.66,
        rounded: true,
        location: {
            x: 31.79,
            y: 4.17,
        },
    },
};
